import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapTouchDownEvent implements MapEvent {
    type = MapEventType.touchStart;
    constructor(public payload: mapboxgl.MapTouchEvent) {}
}
